import { createFileRoute } from "@tanstack/react-router";

import ComingSoonCover from "@/components/ComingSoonCover";

export const Route = createFileRoute(
  "/_staff/equipment/_layout/_placeholders/overview",
)({
  component: () => <ComingSoonCover />,
});
